import template from './savePurchasingAccounts.html';
import controller from './savePurchasingAccounts.controller';

let savePurchasingAccountsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default savePurchasingAccountsComponent;



// WEBPACK FOOTER //
// ./app/components/savePurchasingAccounts/savePurchasingAccounts.component.js